var $2dc518dc2570c4a0$exports = {};
$2dc518dc2570c4a0$exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "placeholder": `Vybrat\u{2026}`
};


export {$2dc518dc2570c4a0$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
